
import { createReducer } from '../store/reducerUtils';

export const key = 'root';

export const LOGIN_DATA = `${key}/LOGIN_DATA`;
export const LOGIN_STATUS = `${key}/LOGIN_STATUS`;
export const GET_HEADERMENU = `${key}/GET_HEADERMENU`;
export const GET_MENU = `${key}/GET_MENU`;
export const LOGIN_ASYNC = `${key}/LOGIN_ASYNC`;

const ACTION_HANDLERS = {
  [LOGIN_DATA]: (state, action) => {
    const initData = action.loginData || {};
    return {
      ...state,
      loginData: {
        errCode: initData.errCode || '01',
        errMsg: initData.errMsg || '',
        menuInfo: initData.menuInfo || {},
        buttonInfoList: initData.buttonInfoList || [],
        userBaseInfo: initData.userBaseInfo || {},
        childMerchantInfoList: initData.childMerchantInfoList || [],
        merchantBaseInfo: initData.merchantBaseInfo || {},
        attachments: initData.attachments || [],
        isManageAll: initData.isManageAll,
        merchantCodes: initData.merchantCodes || '',
      },
    };
  },
  [LOGIN_STATUS]: (state, action) => {
    return {
      ...state,
      loginStatus: action.status,
    };
  },
  [GET_MENU]: (state, action) => {
    return { ...state, menuData: action.menuData };
  },
};

const initialState = {
  loginStatus: 0, // 0loading, 1成功, 2失败
  loginData: {},
  menuData: [],
};

export default createReducer(initialState, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/views/rootReducer.js